import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Market from "../pages/market/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/market",
    element: <Market />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
